import React from 'react';

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-2.5 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
      isActive
        ? 'bg-blue-100 dark:bg-blue-900 text-gray-900 dark:text-white'
        : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
    }`}
  >
    {label}
  </button>
);
